var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Dimmer, Form, Loader, Message } from "semantic-ui-react";
import { postWithAuthn } from "../RequestHelpers";
var ArchiveOrderCommentModal = /** @class */ (function (_super) {
    __extends(ArchiveOrderCommentModal, _super);
    function ArchiveOrderCommentModal(props) {
        var _this = _super.call(this, props) || this;
        _this.submitComment = function () {
            _this.setState({
                loading: true,
                success: false,
                error: false
            }, function () {
                postWithAuthn("/admin/orders/id/" + encodeURIComponent(_this.props.orderId) + "/events/id/" + encodeURIComponent(_this.props.eventId) + "/archive-comment")
                    .then(function (resp) {
                    if (resp.ok) {
                        _this.setState({
                            loading: false,
                            success: true
                        }, _this.props.onSubmit);
                    }
                    else {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                }).catch(function (rej) {
                    console.error("Couldn't submit comment: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            success: false,
            error: false
        };
        return _this;
    }
    ArchiveOrderCommentModal.prototype.render = function () {
        return React.createElement(Dimmer.Dimmable, { as: Form },
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            this.state.success &&
                React.createElement(Message, { positive: true }, "Comment archived."),
            this.state.error &&
                React.createElement(Message, { negative: true }, "Comment could not be archived"),
            React.createElement("br", null),
            React.createElement(Button, { icon: 'archive', labelPosition: "left", label: "Archive Comment", onClick: this.submitComment, positive: true }));
    };
    return ArchiveOrderCommentModal;
}(React.PureComponent));
export default ArchiveOrderCommentModal;
//# sourceMappingURL=ArchiveOrderCommentModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/ArchiveOrderCommentModal.js
// module id = 1244
// module chunks = 0